var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#44B757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5847 19.3396L10.3983 16.3209C10.0577 15.9983 9.52467 15.9974 9.183 16.3188C8.81232 16.6675 8.81128 17.2561 9.18073 17.6061L13.1262 21.3439C13.3833 21.5875 13.7861 21.5875 14.0432 21.3439L23.8239 12.0781C24.1912 11.7302 24.1912 11.1452 23.8239 10.7972C23.4838 10.4749 22.951 10.4748 22.6107 10.7969L13.5847 19.3396Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.990070de08e3883e44157737e1f3ead1.svg";
export { ForwardRef as ReactComponent };